import { render, staticRenderFns } from "./ModalNewSetupPackage.vue?vue&type=template&id=d644c1ee&scoped=true&"
import script from "./ModalNewSetupPackage.vue?vue&type=script&lang=js&"
export * from "./ModalNewSetupPackage.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewSetupPackage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalNewSetupPackage.vue?vue&type=style&index=1&id=d644c1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d644c1ee",
  null
  
)

export default component.exports